/**
 * Retorna o valor de um parâmetro da URL
 */
export function getURLParam(param) {
   return new URLSearchParams(window.location.search).get(param);
}

/**
 * Remove um parâmetro da URL sem recarregar a página
 */
export function removeURLParam(param) {
   const urlParams = new URLSearchParams(window.location.search);
   urlParams.delete(param);
   const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
   window.history.replaceState({}, '', newUrl);
}

/**
 * Faz scroll suave até um elemento com um determinado ID
 */
export function scrollToId(smoother, id, offset = 0) {
   const el = document.getElementById(id);
   if (el) {
      const y = el.getBoundingClientRect().top + smoother.scrollTop() - offset;
      smoother.scrollTo(y, true);
   }
}

/**
 * Escuta cliques em elementos com [data-scroll-to]
 */
export function setupDataScrollTo(smoother, offset = 0) {
   document.querySelectorAll('[data-scroll-to]').forEach(link => {
      link.addEventListener('click', e => {
         e.preventDefault();
         const id = link.getAttribute('data-scroll-to');
         scrollToId(smoother, id, offset);
      });
   });
}
